module.exports = __webpack_public_path__ + "img/logo_bokka_dark_mode.e9e30183.png";